import { constants, typographyStyles } from "@newsela/angelou";

import type { CSSObject } from "@emotion/react";

export const articlePreviewWrapperCss: CSSObject = {
  height: "100%",
  overflowX: "hidden",
  overflowY: "auto",
};

export const titleCss: CSSObject = {
  ...typographyStyles.heading3Obj,
};

export const titleWrapperCss: CSSObject = {
  background: constants.colors.ui.core[25],
  boxSizing: "border-box",
  marginBottom: "0",
  padding: "10px 10px 30px",
};

export const mediaWrapperCss: CSSObject = {
  background: constants.colors.ui.core[25],
  padding: "0 10px",
  boxSizing: "border-box",
};

export const contentWrapperCss: CSSObject = {
  padding: "0 10px 10px",
  boxSizing: "border-box",
};
